import React, { useEffect, useState } from 'react';
import { Col, Row, Button, Badge } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './microscopia.action';
import * as commonActions from '@common/common.action';
import * as certificacaoActions from '@common/certificacao/certificacao.action';
import * as editorActions from '../../editor/editor.action';
import * as acessos from '../../../../acessos.const.util';
import * as editor from '../../editor/editor.util';
import { verificarPlainTextMudou } from '../../editor/editor.util';
import * as modalLiberarParcialmenteAction from '../../modais/liberacao_parcial/store/liberacao.action';
import * as modalLiberarLaudoAction from '../../modais/liberacao_total/store/liberacaoTotal.action';
import { acessoPermitido } from '../../../../acessos.seguranca';
import { LOCAL_STORAGE_USUARIO, getUsuarioLocalStorage } from '../../../../localStorage.util';
import WebapiCommon from '@common/util/webapi.common';
import ProtocoloContainer from '@common/protocolo/protocolo.container';
import MorfologiaContainer from '@common/morfologia/morfologia.container';
import VincularContainer from '@common/vincular/vincular.container';
import ModalConfirmar from '@common/modalConfirmar/modalConfirmar';
import { etapasEnum, statusEtapasEnum } from '@common/util/defaultValues';
import ModalComponent from '@componentes/modal/modal.component';
import ButtonFloating from '@componentes/button/button-floating.component';
import AutorizacaoLaudarContainer from '@common/autorizacaoLaudar/autorizacao-laudar.container';
import CancelamentoComponent from '../../../../componentes/cancelamento/cancelamento.component';
import ModalLiberacaoParcial from '../../modais/liberacao_parcial';
import ModalLiberacaoTotal from '../../modais/liberacao_total';
import HistoricoLaudoContainer from '../macroscopia/tabs/historicolaudo/historico-laudo.container';
import FrascoContainer from '../macroscopia/tabs/frascos/frascos.container';
import ConfirmarCancelamento from '../../../../componentes/cancelamento/confirmacao.component';
import ListaLaminasContainer from '@common/tabs/listaLaminas/lista-laminas.container';
import AnexoContainer from '@common/tabs/anexo/anexo.container';
import AutoTextoContainer from '@common/tabs/autotexto/autotexto.container';
import LaudosAnterioresContainer from '@common/tabs/anteriores/laudos-anteriores.container';
import { errors } from '../../../error/erros';
import ModalConclusao from '@containers/ModalConclusao';
import { editorUrl } from '@constants/defaultValues';
import IntlMessage from '../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';
import ModalEncaminhar from '@common/modalEncaminhar/modalEncaminhar';
import { useHistory } from 'react-router-dom';
import ExamesEmAbertoContainer from '../../etapas/macroscopia/operacoes/exames/exames.container';
import SiscoloModal from '../microscopia/modal/siscolo.modal';
import { urlImagemRadiologia } from '../etapas.common.util';

const MicroscopiaContainer = (props) => {

  const intl = useIntl();
  const history = useHistory();

  const [modalVisivel, setModalVisivel] = useState(false);
  const [modalTitulo, setModalTitulo] = useState('');
  const [modalConteudo, setModalConteudo] = useState(undefined);
  const [modalSize, setModalSize] = useState('lg');
  const [callbackAutorizar, setCallbackAutorizar] = useState(undefined);
  const [modalAutorizacaoLaudar, setModalAutorizacaoLaudar] = useState(false);
  const [showModalCancelamento, setShowModalCancelamento] = useState(false);
  const [modalConfirmarMensagem, setModalConfirmarMensagem] = useState('');
  const [modalConfirmarType] = useState('ok');
  const [justificativaCancelar, setJustificativaCancelar] = useState('');
  const [
    showModalConfirmarCancelamento,
    setShowModalConfirmarCancelamento,
  ] = useState(false);
  const [, setcidPadrao] = useState(false);
  const [modalConfirmar, setModalConfirmar] = useState(false);
  const [totalExamesAbertos] = useState(0);
  const [updateCertificado, setUpdateCertificado] = useState(false);
  const [avisoCertificacao, setAvisoCertificacao] = useState(false);
  const [avisoCertificacaoLiberacao, setAvisoCertificacaoLiberacao] = useState(
    false
  );
  const [textoEditor, setTextoEditor] = useState('');
  const [verificarTexto, setVerificarTexto] = useState(false);
  const [showModalConclusao, setShowModalConclusao] = useState(false);
  const [textoRtf, setTextoRtf] = useState('');
  const [textoPlain, setTextoPlain] = useState('');
  const [tipoVerificacao, setTipoVerificacao] = useState('');
  const [rtfConclusao, setRtfConclusao] = useState('');
  const [plainConclusao, setPlainConclusao] = useState('');
  const usuarioLocal = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_USUARIO)
  );
  const [modalEncaminhar, setModalEncaminhar] = useState(false)
  const [modalSiscolo, setModalSiscolo] = useState(false)
  const [modalEncaminharType, setModalEncaminharType] = useState('ok');
  const [existemImagemsRadiologia, setExistemImagensRadiologia] = useState(false);

  useEffect(() => {
    window.addEventListener('message', ({ data }) => {
      if (data.value) {
        if (data.value.plain) {
          setTextoEditor(data.value.plain);
          setTextoRtf(data.value.rtf);
          setTextoPlain(data.value.plain);

          if (data.args.action == "getTextoMicroAntesDaConclusao") {
            setTextoRtf(data.value.rtf);
            setTextoPlain(data.value.plain);
          }
          //props.commonActions.preencherPlainText(data.value.plain);
          //props.commonActions.changeRtf(data.value.rtf);
        }
      }
    });

    return () => {
      window.removeEventListener('message', null, true);
    }
  }, []);

  const verificarTextoMicroEditor = () => {

    const frame = document.getElementById('iframe-editor');
    if (frame !== null) {
      frame.contentWindow.postMessage(
        {
          method: 'recuperarTextoRtfAndPlainText',
          urlHost: editorUrl,
          args: {
            action: 'getTextoMicroAntesDaConclusao',
          },
        },
        editorUrl
      );
    }
  };

  useEffect(() => {
    props.commonActions.alterarVisibilidadeAbas({});
    document.title = 'Anatomia Patológica';

    try {
      editor.Inicializar(props, etapasEnum.MICRO.toLowerCase());
    } catch (error) {
      let message = error.message;
      let title = '';
      let origin = `Etapa: ${etapasEnum.MICRO}`;
      const code = 101;

      errors.map((err) => {
        if (err.code === code) {
          title = err.title;
        }
        return err;
      });
      window.location.replace(
        `/error/${btoa(title)}/${btoa(message)}/${btoa(code)}/${btoa(origin)}/`
      );
    }

    const laudarEtapaRequest = {
      pendente: true,
      notificacaoCancer: false,
      exameId: props.detalhes.exameId,
      medicoSolicitante: props.detalhes.solicitante,
      medicoEtapa: props.editor.medExecutante,
      medicoRevisor: props.editor.medRevisor,
    };

    props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);

    let etapa = props.detalhes.etapas.find(
      (el) => el.etapa.toLowerCase() === etapasEnum.MICRO.toLowerCase()
    );
    props.actions.microscopiaFinalizada(
      etapa.status === statusEtapasEnum.REALIZADO
    );

    return () => {
      editor.finalizar(props.commonActions);
    };
  }, []);

  useEffect(() => {
    WebapiCommon.verificarSeExistemImagensRadiologica(props.detalhes.acNumber, props.detalhes.prontuario).then((resultado) =>{
      setExistemImagensRadiologia(resultado);
      if (props.editorInicializado && resultado){
        props.commonActions.showAlerta('alerta', <IntlMessage id="dashboards.examDetails.imagesVivaceConnect" />, 7000, '650px');
      }
    });
  }
  , [props.editorInicializado]);

  useEffect(() => {
    if (!props.modalCertificacao && avisoCertificacao && !updateCertificado) {
      setAvisoCertificacao(false);
      setUpdateCertificado(true);
      return laudarConcluir();
    }
    if (
      !props.modalCertificacao &&
      avisoCertificacaoLiberacao &&
      !updateCertificado
    ) {
      setAvisoCertificacaoLiberacao(false);
      setUpdateCertificado(true);
      return liberarLaudo();
    }
  }, [avisoCertificacaoLiberacao, props.modalCertificacao]);

  const fecharModalConfirmar = () => {
    setModalConfirmar(!modalConfirmar);
  };

  const fechar = (e) => {
    props.commonActions.changeFecharTela(true);
    verificarPlainTextMudou();
  };

  const encaminharSegundaOpiniao = () => {
    setModalEncaminhar(!modalEncaminhar)
  }

  const fecharModalEncaminhar = () => {
    setModalEncaminhar(!modalEncaminhar);
  };

  const mostrarModalSiscolo = () => {
    setModalSiscolo(true);
  };

  const fecharModalSiscolo = () => {
    setModalSiscolo(false);
  };

  useEffect(() => {
    if (textoEditor !== undefined && verificarTexto) {
      props.commonActions.showFadeCarregando(true);
      setVerificarTexto(false);

      if (!textoEditor || textoEditor.trim() === '') {
        props.commonActions.showFadeCarregando(false);
        return tipoVerificacao === 'cid' ? showModal('4') : showModal('5');
      } else {
        props.commonActions.showFadeCarregando(false);
        if (tipoVerificacao === 'cid') {
          return showModal('2');
        } else if (tipoVerificacao === 'concluir') {
          const isValid = validarLaudar(false, false);

          if (!isValid) {
            return;
          }
          setShowModalConclusao(!showModalConclusao);
          } else if (tipoVerificacao === 'fechousemsalvar') {
            return;
            }
        else {
          return laudar(false, false);
        }
      }
    }
  },
  [textoEditor, verificarTexto]);

  const verificaEditor = (tipo) => {

    const frame = document.getElementById('iframe-editor'); // iframe-editor-component
    if (frame !== null) {
      frame.contentWindow.postMessage(
        {
          method: 'recuperarTextoRtfAndPlainText',
          urlHost: editorUrl,
          args: {
            action: 'getPlainTextEtapa',
          },
        },
        editorUrl
      );
    }

    setTimeout(() => {
      props.commonActions.showFadeCarregando(false);
      setTipoVerificacao(tipo);
      return setVerificarTexto(true);;
    }, 200);
    // setVerificarTexto(true);

    // return setTipoVerificacao(tipo);

  };

  const _fechar = () => {
    history.goBack();
    //props.commonActions.atualizarDetalhes(undefined);
    props.commonActions.preenhcerHistoricoInconformidades(undefined);
    props.commonActions.atualizarLarguraEditor('100%');
    props.commonActions.showEditor(false);
  };

  const cancelamentoMicrocoscopia = () => {
    setShowModalCancelamento(true);
  };

  const toggleModalCancelamento = () => {
    setJustificativaCancelar('');
    setShowModalCancelamento(false);
  };

  const cancelarEtapasPosteriores = () => {
    props.commonActions.showFadeCarregando(true);
    const listagem = [...props.listagem];
    const listagemIndex = listagem.findIndex(
      (item) => item.laudo === props.detalhes.laudo
    );

    if (listagemIndex >= 0) {
      listagem[listagemIndex].dataLiberacao = '';
      listagem[listagemIndex].isLaudoLiberado = false;
      listagem[listagemIndex].isLiberadoParcial = false;
      listagem[listagemIndex].isLiberadoTotal = false;
      props.commonActions.preencherListagem(listagem);
    }

    WebapiCommon.cancelarEtapasPosteriores(
      props.detalhes.laudo,
      props.etapaAtual,
      0,
      justificativaCancelar
    )
      .then((resp) => {
        if (resp.success) {
          const listagem = [...props.listagem];
          const listagemIndex = listagem.findIndex(
            item => item.laudo === props.detalhes.laudo
          );
          if (listagemIndex >= 0) {
            listagem[listagemIndex].dataLiberacao = '';
            listagem[listagemIndex].isLaudoLiberado = false;
            listagem[listagemIndex].isLiberadoParcial = false;
            listagem[listagemIndex].isLiberadoTotal = false;
            props.commonActions.preencherListagem(listagem);
          }

          props.commonActions.showAlerta('sucesso', resp.data.mensagem, 2000);
          WebapiCommon.obterStatusEtapasLaudo(props.detalhes.laudo).then(
            (etapas) => {
              props.commonActions.atualizarStatusDasEtapasDoLaudo(
                etapas,
                props.detalhes.laudo
              );
              props.commonActions.showEditor(false);
              props.commonActions.showFadeCarregando(false);
              toggleModalCancelamento();
              toggleModalConfirmarCancelamento();
              _fechar();
            }
          );
        } else {
          props.commonActions.showFadeCarregando(false);
          props.commonActions.showAlerta(
            'erro',
            <IntlMessage id="dashboards.examDetail.unableCancelSteps" />,
            2000
          );
          toggleModalCancelamento();
          toggleModalConfirmarCancelamento();
        }
      })
      .catch(() => {
        props.commonActions.showFadeCarregando(false);
        props.commonActions.showAlerta(
          'erro',
          <IntlMessage id="dashboards.examDetail.unableCancelSteps" />,
          2000
        );
        toggleModalCancelamento();
        toggleModalConfirmarCancelamento();
      });
  };

  const liberarLaudo = () => {
    let laudo = props.detalhes;

    if (laudo.liberadoParcial && !laudo.liberadoTotal) {
      props.modalLiberarParcialmenteAction.fecharModal(
        true,
        props.liberacaoParcialHabilitada,
        laudo.laudo
      );
      /// chamar o modal de liberação total passando o laudo para o estado
    } else if (!laudo.liberadoParcial && !laudo.liberadoTotal) {
      /// chamo o modal para liberação parcial
      props.modalLiberarParcialmenteAction.fecharModal(
        false,
        props.liberacaoParcialHabilitada,
        laudo.laudo
      );
    }
  };

  const showModalCancelamentoEtapas = () => {
    setShowModalConfirmarCancelamento(true);
  };

  const toggleModalConfirmarCancelamento = () => {
    setShowModalConfirmarCancelamento(false);
  };

  const setJustificativa = (texto) => {
    setJustificativaCancelar(texto);
  };

  const alterarFullscreen = () => {
    props.commonActions.preencherAtalho('ctrl+alt+f10');
  };

  const showModal = (index) => {
    let componente = undefined;
    let titulo = '';
    let laudo = props.detalhes.laudo;
    let size = 'lg';

    switch (index) {
      case '1':
        componente = <ProtocoloContainer laudo={laudo} />;
        titulo = <IntlMessage id="dashboards.examDetail.protocolRequirements" /> /* `${laudo}` */;
        size = 'xl';
        break;
      case '2':
        componente = (
          <MorfologiaContainer
            cidPadrao={(val) => setcidPadrao(val)}
            altura={window.innerHeight - 215}
          />
        );
        titulo = <IntlMessage id="dashboards.examDetail.CIDReport" /> /* `${laudo}` */;
        break;
      case '3':
        componente = (
          <VincularContainer
            history={history}
            altura={window.innerHeight - 215}
          />
        );
        titulo = <IntlMessage id="dashboards.examDetail.linkPastExams" /> /* `${laudo}`*/;
        break;
      case '4':
        setModalConfirmarMensagem(
          <IntlMessage id="dashboards.examDetail.wasNotTyped" />
        );
        setModalConfirmar(true);
        return;
      case '5':
        setModalConfirmarMensagem(
          <IntlMessage id="dashboards.examDetail.notTyped" />
        );
        setModalConfirmar(true);
        return;
      case '6':
        componente = <ExamesEmAbertoContainer />;
        titulo = intl.formatMessage({ id: "dashboards.examDetails.openExamReport" });
        break;
      case '7':
        setModalConfirmarMensagem(
          <IntlMessage id="dashboards.examDetails.saved" />
        );
        setModalConfirmar(true);
        break;
      default:
        componente = undefined;
        break;
    }

    setModalConteudo(componente);
    setModalTitulo(titulo);
    setModalVisivel(true);
    setModalSize(size);
  };

  const closeModal = () => {
    setModalVisivel(false);
  };

  const construirBotoes = () => {

    let botoes = [];
    botoes.push({
      backgroundColor: '#4375A3',
      className: 'mv-basico-imprimir',
      color: '#ffffff',
      texto: intl.formatMessage({ id: 'dashboards.reports.printOut' }),
      onClick: () => editor.Imprimir(props.commonActions),
    });

    botoes.push({
      backgroundColor: '#3f8642',
      label: '2',
      color: '#ffffff',
      texto: intl.formatMessage({ id: 'dashboards.referral.referral' }),
      onClick: () => encaminharSegundaOpiniao(),
    });

    if(acessoPermitido(props.usuario, acessos.ExamesEmAberto) &&  props.detalhes.siscolo){
      botoes.push({
        backgroundColor: '#3f8642',
        label: 'SIS',
        color: '#ffffff',
        texto: intl.formatMessage({ id: 'Siscolo' }),
        onClick: () => mostrarModalSiscolo(),
      });
    }

    if (acessoPermitido(props.usuario, acessos.ExamesEmAberto) && existemImagemsRadiologia){
      botoes.push({
        backgroundColor: '#3c5d80',
        className:'fas fa-eye',
        // label: 'Imagens',333
        color: '#ffffff',
        texto: intl.formatMessage({ id: 'Vivace Connect' }),
        onClick: () => {
          urlImagemRadiologia(props.commonActions, props.detalhes.acNumber, props.detalhes.prontuario);
        },
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.RequisicaoProtocolo) &&
      props.detalhes.existeBlocoCriado &&
      !props.microscopiaFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        className: 'fas fa-eye-dropper',
        backgroundColor: '#f44336',
        color: '#ffffff',
        texto: intl.formatMessage({ id: 'dashboards.examDetails.protocolRequirements' }),
        onClick: () => showModal('1'),
      });
    }

    if (acessoPermitido(props.usuario, acessos.ExamesEmAberto)) {
      botoes.push({
        backgroundColor: '#17a2b8',
        className: 'fas fa-flask',
        color: '#ffffff',
        texto: intl.formatMessage({ id: 'dashboards.examDetails.openExams' }),
        totalizador: props.quantidadeLaudosEmAberto,
        onClick: () => {
          showModal('6');
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.VincularExame) &&
      acessoPermitido(props.usuario, acessos.Adicionar) &&
      !props.microscopiaFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        className: 'fas fa-link',
        backgroundColor: '#418443',
        color: '#ffffff',
        texto: intl.formatMessage({ id: 'dashboards.examDetail.link' }),
        onClick: () => showModal('3'),
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.TopografiaMorfologia) &&
      !props.microscopiaFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        label: 'CID',
        backgroundColor: '#007bff',
        color: '#ffffff',
        texto: 'CID 10',
        onClick: () => verificaEditor('cid'),
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Microscopia) &&
      acessoPermitido(props.usuario, acessos.Concluir) &&
      !props.microscopiaFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        backgroundColor: '#3f8642',
        className: 'fas fa-save',
        color: '#ffffff',
        texto: intl.formatMessage({ id: 'dashboards.examDetail.laud' }),
        onClick: () => verificaEditor(),
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Microscopia) &&
      acessoPermitido(props.usuario, acessos.ConcluirPendente) &&
      !props.microscopiaFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'far fa-save',
        color: '#ffffff',
        texto: intl.formatMessage({ id: 'dashboards.examDetail.laudPendent' }),
        onClick: () => laudar(true, false),
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Conclusao) &&
      acessoPermitido(props.usuario, acessos.Concluir) &&
      !props.conclusaoFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        backgroundColor: '#3f8642',
        className: 'fas fa-clipboard-check',
        color: '#ffffff',
        texto: intl.formatMessage({ id: 'dashboards.examDetail.laudAndConclusion' }),
        onClick: () => verificaEditor('concluir'),
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Microscopia) &&
      acessoPermitido(props.usuario, acessos.ConcluirConferencia) &&
      !getUsuarioLocalStorage().medicoId &&
      !props.microscopiaFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'fas fa-file-signature',
        color: '#ffffff',
        texto: intl.formatMessage({ id: 'dashboards.examDetail.laudLecturer' }),
        // atalho: 'CTRL+ALT+P',
        onClick: () => laudar(false, false, true),
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.LiberarLaudoParaEntrega) &&
      props.conclusaoFinalizada &&
      (!props.detalhes.liberadoParcial || !props.detalhes.liberadoTotal)
    ) {
      botoes.push({
        backgroundColor: '#3f8642',
        className: 'mv-basico-selecionar_todos',
        color: '#ffffff',
        texto: intl.formatMessage({ id: 'dashboards.examDetails.releaseReport' }),
        onClick: () => liberarLaudo(),
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.CancelamentoMicro) &&
      props.microscopiaFinalizada
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'mv-basico-cancelar',
        color: '#ffffff',
        texto: intl.formatMessage({ id: 'dashboards.examDetail.Cancellation' }),
        atalho: 'CTRL+ALT+N',
        onClick: () => showModalCancelamentoEtapas(),
      });
    }

    botoes.push({
      backgroundColor: '#bbbbbb',
      label: 'F',
      color: '#ffffff',
      texto: intl.formatMessage({ id: 'dashboards.examDetail.close' }),
      onClick: () => fechar(),
    });

    return botoes;
  };

  const editarMedico = (medico) => {
    const etapa = props.detalhes.etapas.find(
      (et) => et.etapa === etapasEnum.MICRO
    );
    let atb = {
      item: 'medico',
      detalhes: 'medMicro',
    };

    if (etapa.status === statusEtapasEnum.REVISAO) {
      atb = {
        item: 'revisor',
        detalhes: 'revisorMicro',
      };
    }
    WebapiCommon.editarMedicoResponsavelLaudo(
      props.detalhes.laudo,
      medico,
      etapasEnum.MICRO,
      atb.item
    ).then(() => {
      let detalhes = {
        ...props.detalhes,
      };
      detalhes[atb.detalhes] = medico;
      props.commonActions.atualizarDetalhes(detalhes);
    });
  };

  const laudar = (pendente, concluir, conferencia = false) => {
    if (!pendente && !conferencia) {
      WebapiCommon.getCIDPorLaudo(props.detalhes.laudo).then((result) => {
        const existe = result.length > 0;
        const cidObrigatorio = props.detalhes.obrigatorioMorfo;
        const existePrincipal = result.find((morfologia) => {
          return morfologia.cidPrincipal;
        });

        if (existePrincipal || !cidObrigatorio) {
          return laudarEtapa(pendente, concluir);
        } else if (existe && !existePrincipal) {
          return props.commonActions.showAlerta(
            'alerta',
            <IntlMessage id="dashboards.examDetail.setCID" />,
            2500
          );
        } else {
          return props.commonActions.showAlerta(
            'alerta',
            <IntlMessage id="dashboards.examDetail.informCID" />,
            2500
          );
        }
      });
    } else {
      return laudarEtapa(pendente, concluir, conferencia);
    }
  };

  const laudarConcluir = (texto) => {
    texto && texto.rtf && setRtfConclusao(texto.rtf);
    texto && texto.plain && setPlainConclusao(texto.plain);
    const CurrentRtfConclusao = texto && texto.rtf ? texto.rtf : rtfConclusao;
    const CurrentPlainConclusao = texto && texto.plain ? texto.plain : plainConclusao;

    // Validar Certificação
    if (
      !avisoCertificacao &&
      !props.detalhes.certificado &&
      props.detalhes.habilitadoCertificacao &&
      acessoPermitido(props.usuario, acessos.CertificacaoDigital)
    ) {
      props.certificacaoActions.certificadosSelecionados([
        props.detalhes.laudo,
      ]);
      props.certificacaoActions.showModal(true);
      setAvisoCertificacao(true);
    } else {

      let laudarEtapaRequest = {
        ...props.laudarEtapaRequest,
        pendente: false,
        concluirLaudo: true,
        medicoSolicitante: props.detalhes.solicitante,
        medicoEtapa: props.editor.medExecutante,
        medicoRevisor: props.editor.medRevisor,
        medicoLogadoId: usuarioLocal.medicoId,
        laudarParaConferencia: false,
        rtfEtapa: textoRtf,
        plainEtapa: textoPlain,
        rtfConclusao: CurrentRtfConclusao,
        plainConclusao: CurrentPlainConclusao,
      };

      if (usuarioLocal.isResidente) {
        setModalAutorizacaoLaudar(true);
        setCallbackAutorizar({
          sucesso: (medico_autorizou) => {
            setModalAutorizacaoLaudar(false);
            editarMedico(medico_autorizou);
            props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);
            editor.laudar(props.commonActions, true);
            props.commonActions.showAlerta(
              'sucesso',
              <IntlMessage id="dashboards.examDetail.reportSave" />,
              2000
            );

            history.goBack();
          },
          error: () => {
            props.commonActions.showAlerta(
              'erro',
              <IntlMessage id="dashboards.examDetail.notAllowed" />,
              2000
            );
          },
        });
      } else {
        props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);
        editor.laudar(props.commonActions, true);
      }
    }

  };

  const validarLaudar = (pendente, conferencia) => {
    if (!usuarioLocal.medicoId && !pendente && !conferencia) {
      props.commonActions.showAlerta(
        'erro',
        <IntlMessage id="dashboards.examDetail.onlyDoctors" />,
        2000
      );
      return false;
    }
    const etapaMacro = props.detalhes.etapas.find(
      (el) => el.etapa.toLowerCase() === etapasEnum.MACRO.toLowerCase()
    );

    if (
      etapaMacro.status !== statusEtapasEnum.REALIZADO &&
      !pendente &&
      etapaMacro.status !== statusEtapasEnum.CONFERENCIA
      && etapaMacro.status !== statusEtapasEnum.NAO_APLICAVEL
    ) {
      const mensagem =
        'É necessário finalizar a MACRO antes de realizar esta ação!';
      props.commonActions.showAlerta('erro', mensagem, 5000, '500px');
      return false;
    }
    return true;
  }

  const laudarEtapa = (pendente, concluir, conferencia = false) => {
    const isValid = validarLaudar(pendente, conferencia);
    if (!isValid) {
      return;
    }
    let laudarEtapaRequest = {
      ...props.laudarEtapaRequest,
      pendente: pendente,
      concluirLaudo: concluir,
      medicoSolicitante: props.detalhes.solicitante,
      medicoEtapa: props.editor.medExecutante,
      medicoRevisor: props.editor.medRevisor,
      medicoLogadoId: usuarioLocal.medicoId,
      laudarParaConferencia: conferencia,
    };

    if (usuarioLocal.isResidente && !pendente && !conferencia) {
      setModalAutorizacaoLaudar(true);
      setCallbackAutorizar({
        sucesso: (medico_autorizou) => {
          setModalAutorizacaoLaudar(false);
          editarMedico(medico_autorizou);
          props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);
          editor.laudar(props.commonActions);
          props.commonActions.showAlerta(
            'sucesso',
            <IntlMessage id="dashboards.examDetail.reportSave" />,
            2000
          );

          history.goBack();
        },
        error: () => {
          props.commonActions.showAlerta(
            'erro',
            <IntlMessage id="dashboards.examDetail.notAllowed" />,
            2000
          );
        },
      });
    } else {
      props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);
      editor.laudar(props.commonActions);
      props.commonActions.showAlerta(
				'sucesso',
				intl.formatMessage({id:"dashboards.examDetail.reportSave"}),
				2000
			);
    }
  };

  const alterarVisibilidadeAbas = (propriedadeNoEstado) => {
    const visibilidade = !props[propriedadeNoEstado];
    const larguraEditor = visibilidade
      ? 'calc(100% - 33.333333% - 10px)'
      : '100%';
    props.commonActions.alterarVisibilidadeAbas({
      [propriedadeNoEstado]: visibilidade,
    });
    props.commonActions.atualizarLarguraEditor(larguraEditor);
  };

  const laudarConclusao = (texto) => {
    verificarTextoMicroEditor();
    laudarConcluir(texto);
  }

  return (
    <React.Fragment>
      <ModalEncaminhar
        toggleModalEncaminhar={() => setModalEncaminhar(!modalEncaminhar)}
        type={modalEncaminharType}
        showModalEncaminhar={modalEncaminhar}
        titulo={'Encaminhar'}
        mensagem={'Encaminhar'}
        confirmar={() => fecharModalEncaminhar()}
        laudo={props.detalhes.laudo}
        commonActions={props.commonActions}
      />
  {modalSiscolo && (
   <SiscoloModal
					isOpen={modalSiscolo}
					toggle={fecharModalSiscolo}
					laudo={props.detalhes.laudo}
          detalhesLaudo={props.detalhes}
          onClose={() => {
            editor.Inicializar(props, etapasEnum.MICRO.toLowerCase());
          }}
				/>)}
      <ModalConclusao
        onModal={(e) => {
          setShowModalConclusao(e);
        }}
        showModal={showModalConclusao}
        confirmar={(e) => {
          laudarConclusao(e)
        }}
      />
      <ModalConfirmar
        toggleModalConfirmar={() => setModalConfirmar(!modalConfirmar)}
        type={modalConfirmarType}
        showModalConfirmar={modalConfirmar}
        titulo={<IntlMessage id="dashboards.examDetail.headsUp" />}
        mensagem={modalConfirmarMensagem}
        confirmar={() => fecharModalConfirmar()}
      />
      <React.Fragment>
        <ConfirmarCancelamento
          isOpen={showModalConfirmarCancelamento}
          toggle={toggleModalConfirmarCancelamento}
          setJustificativa={setJustificativa}
          justificativaCancelar={justificativaCancelar}
          shoModalJustificativa={cancelamentoMicrocoscopia}
        />
        <CancelamentoComponent
          isOpen={showModalCancelamento}
          toggle={toggleModalCancelamento}
          setJustificativa={setJustificativa}
          justificativaCancelar={justificativaCancelar}
          cancelarEtapa={cancelarEtapasPosteriores}
        />
        <ModalLiberacaoParcial />
        <ModalLiberacaoTotal />
        <ModalComponent
          size={modalSize}
          visivel={modalVisivel}
          cancela={closeModal}
          titulo={modalTitulo}
        >
          {modalConteudo}
        </ModalComponent>
        {modalAutorizacaoLaudar && (
          <AutorizacaoLaudarContainer
            fecharTela={() => setModalAutorizacaoLaudar(false)}
            callback={callbackAutorizar}
          />
        )}
        {props.detalhes !== undefined && (
          <Col className="paddingZero">
            <div
              style={{ height: '100%' }}
              className="detalhes-micro-container"
            >
              <div className="inner-menu-container">
                <Row>
                  {acessoPermitido(props.usuario, acessos.AutoTexto) &&
                    !props.exameFinalizado &&
                    !props.microscopiaFinalizada && (
                      <Col>
                        <Button
                          className={
                            props.visibilidadeAutotexto
                              ? 'mv-tab-ativo'
                              : undefined
                          }
                          onClick={() =>
                            alterarVisibilidadeAbas('visibilidadeAutotexto')
                          }
                          color="link"
                          title="CTRL+ALT+A"
                        >
                          <IntlMessage id="dashboards.examDetails.autoText" />
                        </Button>
                      </Col>
                    )}
                  {acessoPermitido(props.usuario, acessos.Anexo) && (
                    <Col>
                      <Button
                        color="link"
                        className={
                          props.visibilidadeListagemAnexo
                            ? 'mv-tab-ativo'
                            : undefined
                        }
                        onClick={() =>
                          alterarVisibilidadeAbas('visibilidadeListagemAnexo')
                        }
                      >
                        <IntlMessage id="dashboards.examDetails.attachments" />
                      </Button>
                    </Col>
                  )}

                  {acessoPermitido(props.usuario, acessos.LaudosAnteriores) && (
                    <Col>
                      <Button
                        className={`${totalExamesAbertos > 0
                          ? 'alerta-exame-aberto'
                          : props.visibilidadeLaudosAnteriores
                            ? 'mv-tab-ativo'
                            : props.visibilidadeLaudosAnteriores &&
                              totalExamesAbertos
                              ? 'mv-tab-ativo alerta-exame-aberto'
                              : ''
                          }`}
                        onClick={() =>
                          alterarVisibilidadeAbas(
                            'visibilidadeLaudosAnteriores'
                          )
                        }
                        color="link"
                        title="CTRL+ALT+T"
                      >
                        <IntlMessage id="dashboards.examDetails.previousReports" />
                        <Badge className="tabs-total-itens">
                          {props.quantidadeLaudosAnteriores}
                        </Badge>
                      </Button>
                    </Col>
                  )}
                  {acessoPermitido(props.usuario, acessos.HistoricoLaudo) && (
                    <Col>
                      <Button
                        className={
                          props.visibilidadeHistoricoLaudo
                            ? 'mv-tab-ativo'
                            : undefined
                        }
                        onClick={() =>
                          alterarVisibilidadeAbas('visibilidadeHistoricoLaudo')
                        }
                        color="link"
                        title="CTRL+ALT+H"
                      >
                        <IntlMessage id="dashboards.examDetails.reportHistory" />
                      </Button>
                    </Col>
                  )}
                  {acessoPermitido(props.usuario, acessos.ListaLaminas) &&
                    !props.exameFinalizado &&
                    !props.microscopiaFinalizada && (
                      <Col>
                        <Button
                          color="link"
                          className={
                            props.visibilidadeListaLaminas
                              ? 'mv-tab-ativo'
                              : undefined
                          }
                          onClick={() =>
                            alterarVisibilidadeAbas('visibilidadeListaLaminas')
                          }
                        >
                          <IntlMessage id="dashboards.examDetails.bladeList" />
                        </Button>
                      </Col>
                    )}
                  {acessoPermitido(props.usuario, acessos.ListaFrasco) &&
                    !props.exameFinalizado &&
                    !props.microscopiaFinalizada && (
                      <Col>
                        <Button
                          className={
                            props.visibilidadeFrascos
                              ? 'mv-tab-ativo'
                              : undefined
                          }
                          onClick={() =>
                            alterarVisibilidadeAbas('visibilidadeFrascos')
                          }
                          color="link"
                          title="CTRL+ALT+F"
                        >
                          <IntlMessage id="dashboards.examDetail.listBlocks" />
                        </Button>
                      </Col>
                    )}
                  <Col>
                    <Button
                      onClick={alterarFullscreen}
                      color="link"
                      title="CTRL+ALT+F10"
                    >
                      <i
                        className={
                          window.document.fullscreen
                            ? 'fas fa-compress'
                            : 'fas fa-expand'
                        }
                      ></i>
                    </Button>
                  </Col>
                </Row>
              </div>
              <Row className="mv-tabs-container">
                {props.visibilidadeListaLaminas && (
                  <Col
                    style={{
                      paddingLeft: '15px',
                      minWidth: '0%',
                      maxWidth: '30%',
                    }}
                  >
                    <ListaLaminasContainer altura={props.altura} />
                  </Col>
                )}

                {props.visibilidadeLaudosAnteriores &&
                  acessoPermitido(props.usuario, acessos.LaudosAnteriores) && (
                    <Col
                      style={{
                        paddingLeft: '15px',
                        minWidth: '0%',
                        maxWidth: '30%',
                      }}
                    >
                      <LaudosAnterioresContainer altura={props.altura} />
                    </Col>
                  )}
                {props.visibilidadeAutotexto &&
                  acessoPermitido(props.usuario, acessos.AutoTexto) && (
                    <Col
                      style={{
                        paddingLeft: '15px',
                        minWidth: '0%',
                        maxWidth: '30%',
                      }}
                    >
                      <AutoTextoContainer altura={props.altura} />
                    </Col>
                  )}
                {props.visibilidadeListagemAnexo &&
                  acessoPermitido(props.usuario, acessos.Anexo) && (
                    <Col
                      style={{
                        paddingLeft: '15px',
                        minWidth: '0%',
                        maxWidth: '30%',
                      }}
                    >
                      <AnexoContainer altura={props.altura} />
                    </Col>
                  )}
                {props.visibilidadeFrascos &&
                  acessoPermitido(props.usuario, acessos.ListaFrasco) && (
                    <Col
                      style={{
                        paddingLeft: '15px',
                        minWidth: '0%',
                        maxWidth: '30%',
                      }}
                    >
                      <FrascoContainer altura={props.altura} />
                    </Col>
                  )}

                {props.visibilidadeHistoricoLaudo &&
                  acessoPermitido(props.usuario, acessos.HistoricoLaudo) && (
                    <Col
                      style={{
                        paddingLeft: '15px',
                        minWidth: '0%',
                        maxWidth: '30%',
                      }}
                    >
                      <HistoricoLaudoContainer altura={props.altura} />
                    </Col>
                  )}
                <Col
                  style={{
                    paddingLeft: '0px',
                    minWidth: '70%',
                    maxWidth: '100%',
                  }}
                >
                  <div
                    id="container-editor-etapa"
                    style={{ height: '100%' }}
                  ></div>
                </Col>
              </Row>

              <ButtonFloating actions={construirBotoes()} />
            </div>
          </Col>
        )}
      </React.Fragment>
    </React.Fragment>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    certificacaoActions: bindActionCreators(certificacaoActions, dispatch),
    editorActions: bindActionCreators(editorActions, dispatch),
    modalLiberarParcialmenteAction: bindActionCreators(
      modalLiberarParcialmenteAction,
      dispatch
    ),
    modalLiberarLaudoAction: bindActionCreators(
      modalLiberarLaudoAction,
      dispatch
    ),
  };
};

const mapStateToProps = (state) => {
  return {
    modalCertificacao: state.certificacao.showModal,
    editor: state.editor,
    usuario: state.usuario,
    altura: state.commonReducer.altura,
    detalhes: state.commonReducer.detalhes,
    editorCarregado: state.commonReducer.editorCarregado,
    laudarEtapaRequest: state.commonReducer.laudarEtapaRequest,
    listagem: state.commonReducer.listagem,
    exameFinalizado: state.commonReducer.exameFinalizado,
    microscopiaFinalizada: state.microscopia.microscopiaFinalizada,
    etapaAtual: state.commonReducer.etapa.etapa,
    visibilidadeFrascos: state.commonReducer.visibilidadeFrascos,
    visibilidadeListaLaminas: state.commonReducer.visibilidadeListaLaminas,
    visibilidadeAutotexto: state.commonReducer.visibilidadeAutotexto,
    visibilidadeLaudosAnteriores:
    state.commonReducer.visibilidadeLaudosAnteriores,
    visibilidadeListagemAnexo: state.commonReducer.visibilidadeListagemAnexo,
    visibilidadeHistoricoLaudo: state.commonReducer.visibilidadeHistoricoLaudo,
    quantidadeLaudosAnteriores: state.commonReducer.quantidadeLaudosAnteriores,
    quantidadeLaudosEmAberto: state.commonReducer.quantidadeLaudosEmAberto,
    rtf: state.commonReducer.rtf,
    plainTextLaudo: state.commonReducer.plainTextLaudo,
    editorInicializado: state.commonReducer.editorInicializado
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MicroscopiaContainer);


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/microscopia/microscopia.container.js